<template>
    <div class="messages">
        <div v-if="loading" class="text-center">
          <b-spinner variant="cta"/>
        </div>
        <b-container fluid v-else>
            <b-row>
              <b-col cols="10" lg="6" offset-lg="2">
                <div class="messages--actions">
                  <b-form-textarea
                      ref="user_changes_request"
                      id="user_changes_request"
                      v-model="message"
                      placeholder="Testo del messaggio"
                  ></b-form-textarea>
                </div>
              </b-col>
              <b-col cols="2">
                <div class="messages--actions">
                  <button-with-icon
                      variant="cta"
                      text="Invia"
                      :disabled="message == ''"
                      :icon="chevron_right"
                      :clicked="() => { post_message() }"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
                <b-col cols="10" lg="8" offset-lg="2">
                    <div class="messages--items">
                        <ul class="messages--list">
                          <li class="messages--item" v-for="(message, index) in messages" v-bind:key="'my_message_' + index">
                            <div class="messages--item--from" v-html="message.from"></div>
                            <div class="messages--item--content" v-html="message.message"></div>
                            <div class="messages--item--at">
                              {{ message.created_at | moment("DD-MM-YYYY HH:mm") }}
                            </div>
                          </li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {get_messages, post_message} from "@/api";
    import {custom_event} from "@/utilities";
    import Bwi from '@/components/atoms/button-with-icon'
    import { chevron_right } from '@/components/svg/chevrons'

    export default {
        name: 'messages',
        components: {
          'button-with-icon': Bwi,
        },
        props:{
          request_id: String,
          secret: String,
          noTrack: {
            type: Boolean,
            default: false,
          }
        },
        data() {
            return {
              loading: true,
              messages: {},
              message: '',
            }
        },
        computed: {
        },
        created()
        {
        },
        mounted() {
          this.chevron_right = chevron_right
          this.get_messages()
        },
        methods:{

          get_messages() {
            this.loading = true
            get_messages({ request_id: this.request_id, secret: this.secret })
              .then(
                (success) => {
                  this.messages = success.data.messages.sort((a,b) => { return b.id - a.id }) // desc
                  this.loading = false
                },
              )
          },

          post_message(){
            if(this.message == '') return
            this.loading = true
            post_message({request_id: this.request_id, secret: this.secret, message: this.message})
              .then(
                (success) => {
                  (success)
                  this.message = ''
                  this.get_messages()
                  custom_event('messageSent')
                },
                (error) => {
                  (error)
                  this.loading = false
                }
              )
          }
        },
    }
</script>

<style lang="scss">
.messages
{
  margin-top:140px;
  @include media-breakpoint-up(md)
  {
    margin-top:240px
  }

  &--items
  {
    margin-bottom:$grid-gutter-width/2;
  }

  &--list
  {
    list-style:none;
    margin:0;
    padding:0;
    border:1px solid $gray-400;
    border-radius: $border-radius-sm;
  }

  &--item
  {
    margin:0;
    padding:0;
    padding:1rem;
    &:nth-child(even)
    {
      background:rgba($white,0.5);
    }
    &:nth-child(odd)
    {
      background:rgba($gray-300,0.5);
    }

    &--from
    {
      font-weight: bold;
      color:$primary;
      line-height: 1;
      font-size: 18px;
      margin-bottom:8px;
    }

    &--content
    {
    }

    &--at
    {
      text-align: right;
      font-size: 11px;
      font-style: italic;
      color:$gray-600;
    }
  }

  .form-control
  {
    border-radius: $border-radius-sm;
    margin-bottom:$grid-gutter-width/2;
  }

  .bwi
  {
    //display: inline-block;
    //margin:0 auto;
    width:100%;
  }

  &--actions
  {
    text-align: right;
    display:flex;
    align-items: center;
  }
}
</style>